import process from "next/dist/build/webpack/loaders/resolve-url-loader/lib/postcss";

export const getProducts = async (urlParams = {}) => {
    const url = new URL(process.env.NEXT_PUBLIC_API_URL + '/pzn/v1/products');
    let filterParams = Object.fromEntries(
        Object.entries(urlParams).filter(([key, value]) => value !== null && value !== undefined)
    )

    const params = {
        consumer_key: process.env.NEXT_PUBLIC_WC_CUSTOMER_KEY,
        consumer_secret: process.env.NEXT_PUBLIC_WC_CUSTOMER_SECRET
    };

    if(!filterParams?.paged) {
        filterParams = {
            ...filterParams,
            paged: 1
        }
    }

    if(!filterParams?.per_page) {
        filterParams = {
            ...filterParams,
            per_page: process.env.NEXT_PUBLIC_PER_PAGE
        }
    }

    url.search = new URLSearchParams({
        ...filterParams,
        ...params
    }).toString();

    const result = await fetch(url, { next: { revalidate: parseInt(process.env.NEXT_PUBLIC_CACHE_REVALIDATE) } })
    return await result.json()
}

export const getWCProducts = async (urlParams = {}) => {
    const url = new URL(process.env.NEXT_PUBLIC_API_URL + '/wc/v3/products');
    let filterParams = urlParams
    const params = {
        consumer_key: process.env.NEXT_PUBLIC_WC_CUSTOMER_KEY,
        consumer_secret: process.env.NEXT_PUBLIC_WC_CUSTOMER_SECRET
    };

    if(!filterParams?.page) {
        filterParams = {
            ...filterParams,
            page: 1
        }
    }

    if(!filterParams?.per_page) {
        filterParams = {
            ...filterParams,
            per_page: process.env.NEXT_PUBLIC_PER_PAGE
        }
    }

    url.search = new URLSearchParams({
        ...filterParams,
        ...params
    }).toString();

    const result = await fetch(url, { next: { revalidate: parseInt(process.env.NEXT_PUBLIC_CACHE_REVALIDATE) } })
    const resultJson = await result.json()
    return { data: resultJson, total: result.headers.get('x-wp-total'), totalPages: result.headers.get('x-wp-totalpages') }
}

export const getWCSpecialProducts = async (urlParams = {}) => {
    const url = new URL(process.env.NEXT_PUBLIC_API_URL + '/wc/v3/products');
    const params = {
        consumer_key: process.env.NEXT_PUBLIC_WC_CUSTOMER_KEY,
        consumer_secret: process.env.NEXT_PUBLIC_WC_CUSTOMER_SECRET
    };
    url.search = new URLSearchParams({
        ...urlParams,
        ...params
    }).toString();
    
    const result = await fetch(url, { next: { revalidate: parseInt(process.env.NEXT_PUBLIC_CACHE_REVALIDATE) } })
    const resultJson = await result.json()
    return { data: resultJson, count: result.headers.get('x-wp-total'), totalPages: result.headers.get('x-wp-totalpages') }
}

export const getProduct = async (id) => {
    const url = new URL(process.env.NEXT_PUBLIC_API_URL + '/wc/v3/products/' + id);
    const params = {
        consumer_key: process.env.NEXT_PUBLIC_WC_CUSTOMER_KEY,
        consumer_secret: process.env.NEXT_PUBLIC_WC_CUSTOMER_SECRET
    };
    url.search = new URLSearchParams(params).toString();

    const result =  await fetch(url, {next: {revalidate: parseInt(process.env.NEXT_PUBLIC_CACHE_REVALIDATE)}})

    return await result.json()
}

export const getProductBySlug = async (slug) => {
    const url = new URL(process.env.NEXT_PUBLIC_API_URL + '/wc/v3/products');
    const params = {
        slug: slug,
        consumer_key: process.env.NEXT_PUBLIC_WC_CUSTOMER_KEY,
        consumer_secret: process.env.NEXT_PUBLIC_WC_CUSTOMER_SECRET
    };
    url.search = new URLSearchParams(params).toString();

    const result = await fetch(url, {next: {revalidate: parseInt(process.env.NEXT_PUBLIC_CACHE_REVALIDATE)}})

    return await result.json()
}